document.addEventListener("DOMContentLoaded", function () {

    // Si el usuario ya cerró el popup anteriormente
    if (localStorage.getItem("gl_popup_closed") === "1") {
        return;
    }

    // No mostrar en Perú
    const country = (window.GL_COUNTRY || "").toUpperCase();

console.log("País:", country);

if (country === "PE") {
    return;
}

    const overlay = document.getElementById("gl-overlay");

    if (!overlay) return;

    // Mostrar popup
    overlay.style.display = "flex";

    // Botón ir a la tienda internacional
    const btn = document.getElementById("gl-go-intl");

    if (btn) {

        btn.addEventListener("click", function () {

            localStorage.setItem("gl_popup_closed", "1");

            window.location.assign(
                "https://ghiamlopezwatches.com" +
                window.location.pathname +
                window.location.search
            );

        });

    }

});

// Cerrar popup
document.addEventListener("click", function (e) {

    if (
        e.target.id === "gl-close" ||
        e.target.id === "gl-stay"
    ) {

        localStorage.setItem("gl_popup_closed", "1");

        const overlay = document.getElementById("gl-overlay");

        if (overlay) {
            overlay.style.display = "none";
        }

    }

});